export default __webpack_public_path__ + "static/media/chrzest.f02cefea.jpg";